export default __webpack_public_path__ + "static/media/Primer_Mix_of_Primers_2_and_5.0fc245dd.svg";